import PropTypes from "prop-types";
import {
    renderSingleNavItem,
    renderHiddenMenu,
} from "../ResponsiveNav/component";
import classNames from "classnames";
import { VIEWPORT_MOBILE } from "./constants";
import { useResponsiveBehaviour } from "../../../../hooks/useResponsiveNav";
import LinkWrap from "../../../LinkWrap/component";
import featureAttr from "../../../../utils/featureAttr";

/**
 * This component shrinks or grows depending on the window size. It displays the items that don&#39;t fit in the viewport via MoreItemsNav
 */
const OlympicsResponsiveNav = ({
    items = null,
    baseNavSection = "",
    subSection = "",
    path = "",
    className,
    viewport = "",
    collapseOnMobile = true,
    id = "",
    moreButtonLabel = "",
    isExternalHeader = false,
}) => {
    const config = {
        collapseOnMobile,
        usingRightSideNav: true,
    };
    const { assignRef, getHiddenItemsCount } = useResponsiveBehaviour(
        items,
        path,
        config
    );
    const hiddenItemsCount = getHiddenItemsCount();

    let renderNavItems = "";
    const allHidden = viewport === VIEWPORT_MOBILE;
    let hiddenItems = allHidden ? items : null;
    let splitIndex = 0;
    let isVisible = true;

    if (items && !allHidden) {
        splitIndex = items.length - hiddenItemsCount;
        hiddenItems = items.slice(splitIndex, items.length);

        // Render list items
        renderNavItems = items.map((item, index) => {
            if (hiddenItemsCount) {
                isVisible = index < splitIndex ? true : false;
            }
            return renderSingleNavItem(
                { isExternalHeader, path },
                {
                    value: item,
                    index,
                    isVisible,
                }
            );
        });
    }

    const classes = classNames("subNavList", className, {
        allHidden: allHidden || !splitIndex,
    });

    const isPara = baseNavSection === "olympics-paralympics";

    return (
        <div
            className="olympicsResponsiveNav"
            {...featureAttr({
                name: "navigation",
                instance: "secondary-navigation",
            })}
            data-testid="olympics-responsive-nav"
            data-cy="olympics-responsive-nav"
            title="Olympics Section Menu"
        >
            <ul className={classes} ref={(ref) => assignRef(ref)} id={id}>
                {renderNavItems}
                {renderHiddenMenu(
                    {
                        baseNavSection,
                        subSection,
                        path,
                        moreButtonLabel,
                        isExternalHeader,
                        id,
                    },
                    hiddenItems,
                    hiddenItemsCount,
                    allHidden
                )}
                <div className="rightAlignNav" data-cy="right-nav">
                    <LinkWrap
                        url={
                            isPara
                                ? "/player/sports/paralympics/summer/replays"
                                : "/player/sports/olympics/summer/replays"
                        }
                        className="watchReplaysLink"
                        data-feature-name="navigation"
                        data-feature-instance="secondary-navigation"
                    >
                        Watch Replays
                    </LinkWrap>
                    <LinkWrap
                        url={
                            isPara
                                ? "/player/sports/paralympics/summer/live"
                                : "/player/sports/olympics/summer/live"
                        }
                        className="watchLiveLink"
                        data-feature-name="navigation"
                        data-feature-instance="secondary-navigation"
                    >
                        Watch Live
                        <span className="a11y">End of section</span>
                    </LinkWrap>
                </div>
            </ul>
        </div>
    );
};

OlympicsResponsiveNav.propTypes = {
    items: PropTypes.array,
    baseNavSection: PropTypes.string,
    subSection: PropTypes.string,
    path: PropTypes.string,
    className: PropTypes.string,
    viewport: PropTypes.string,
    collapseOnMobile: PropTypes.bool,
    id: PropTypes.string,
    moreButtonLabel: PropTypes.string,
    isExternalHeader: PropTypes.bool,
};

export default OlympicsResponsiveNav;
